import { OrderedMap as ImmutableMap, Seq as ImmutableSeq } from 'immutable';
function defaultHashFunction(args) {
  if (args.length === 1) {
    return args[0];
  }
  return ImmutableSeq(args);
}
export function lruMemoize(fn, limit = 500, generateKeyFn = defaultHashFunction) {
  const cache = ImmutableMap().asMutable();
  return (...args) => {
    const key = generateKeyFn(args);
    if (cache.has(key)) {
      // Move to end (most recently used)
      const value = cache.get(key);
      cache.delete(key);
      cache.set(key, value);
      return value;
    }
    const result = fn(...args);
    if (cache.size >= limit) {
      // Remove least recently used (Map guarantees iteration on order of insertion)
      const firstKey = cache.keys().next().value;
      if (firstKey) {
        cache.delete(firstKey);
      }
    }
    cache.set(key, result);
    return result;
  };
}